import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import {
  ProtocolQuestionEditRootState,
  removeQuestion,
  saveStateDebounced,
  startQuestionEdit,
  toggleQuestionVisibility,
  updateQuestion,
} from "./protocol-question-edit.slice";

export const protocolQuestionEditListener = createListenerMiddleware<ProtocolQuestionEditRootState>();

protocolQuestionEditListener.startListening({
  matcher: isAnyOf(updateQuestion, startQuestionEdit, toggleQuestionVisibility, removeQuestion),
  effect: (action, listenerApi) => {
    const state = listenerApi.getState().protocolQuestionEdit;
    saveStateDebounced(state);
  },
});

export const protocolQuestionEditMiddleware = protocolQuestionEditListener.middleware;
